/**
 * @import { AnsiPalette } from '../ansi.types.js'
 */

/** @type {AnsiPalette} */
export default {
  foreground: '#565A6E',
  background: '#D5D6DB',
  'background-hover': '#CBCCD1',
  'background-selected': '#C1C2C7',
  black: '#0F0F14',
  red: '#8C4351',
  green: '#485E30',
  yellow: '#855215',
  blue: '#34548A',
  magenta: '#5A4A78',
  cyan: '#0F4B6E',
  white: '#343B58',
  'bright-black': '#9699A3',
  'bright-red': '#8C4351',
  'bright-green': '#485E30',
  'bright-yellow': '#855215',
  'bright-blue': '#34548A',
  'bright-magenta': '#5A4A78',
  'bright-cyan': '#0F4B6E',
  'bright-white': '#343B58',
};
